import { array, minLength, nonOptional, object, pipe, string, url } from "valibot";
import type WebhookId from "../state/WebhookId";
import { errorTranslation, requireText } from "../utils/validation/base";
import { MAX_CHARACTERS_MD, MAX_CHARACTERS_SM } from "../constants";
import type EventId from "../state/EventId";
import { keyFromSelector } from "i18next";

export type Webhook = {
  id: WebhookId;
  name: string;
  url: string;
  enabled: boolean;
  type: string[];
  secret: string;
};

export type WebhookInvocation = {
  eventId: EventId;
  type: string;
  status: "SUCCESS" | "FAILED" | "UNKNOWN";
  httpStatusCode: number;
  message: string;
  invokedOn: Date;
  retryOn?: Date;
};

export const upsertWebhookSchema = object({
  name: requireText(MAX_CHARACTERS_SM),
  url: pipe(requireText(MAX_CHARACTERS_MD), url(errorTranslation(keyFromSelector(($) => $.VALIDATION_URL)))),
  type: nonOptional(
    pipe(array(string()), minLength(1, errorTranslation(keyFromSelector(($) => $.VALIDATION_NOT_EMPTY)))),
    errorTranslation(keyFromSelector(($) => $.VALIDATION_NOT_EMPTY)),
  ),
});
